import React, { useRef, useState } from 'react';
import AsyncSelect from 'react-select/async';
import { getMedicalByID, validHIS } from './ApiMethods';
import AppLoader from '../../../components/AppLoader';
import SmallEmrCard from './SmallEmrCard';
import EmrCard from './EmrCard';

const PatientEMRList = () => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const emptyOptionsMessage = useRef('search');
  const [emrData, setEmrData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [viewEmrDetails, setViewEmrDetails] = useState(null);

  const loadOptions = async inputValue => {
    const payload = { query: inputValue };
    const response = await validHIS.post('searchPatient', payload);
    if (!response?.data?.data?.length) {
      emptyOptionsMessage.current = 'No options found';
      return [];
    }
    return response?.data?.data?.map(({ full_name, patient_id }) => ({ label: full_name, value: patient_id }));
  };

  const handleChange = optionValue => {
    setSelectedPatient(optionValue);
    let payload = {
      page: 1,
      perPage: 50,
      patientID: optionValue?.value
    };
    getMedicalByID(setLoading, payload, setEmrData);
  };

  const getAsyncValue = () => {
    return selectedPatient && { label: selectedPatient?.label, value: selectedPatient?.value };
  };
  return (
    <div className='superGit_container !p-0'>
      <div>
        {viewEmrDetails !== null ? (
          <EmrCard entry={viewEmrDetails} setData={setViewEmrDetails} />
        ) : (
          <div>
            <div className='flex justify-between flex-col lg:flex-row gap-4 mb-3 px-3'>
              <div className=''>
                <span className='font-semibold text-black/70 text-lg '>PATIENT EMR</span>
              </div>
              <div>
                <AsyncSelect
                  classNames={{
                    control: state => (state.isFocused ? '!border-primary' : '!border-gray-300')
                  }}
                  classNamePrefix='select'
                  className={`!cursor-text !p-0 !w-[300px] border-gray-300 rounded-md hover:!border-primary !outline-none shadow-none `}
                  loadOptions={loadOptions}
                  value={getAsyncValue()}
                  onChange={handleChange}
                  placeholder='Search Patient'
                  noOptionsMessage={() => emptyOptionsMessage.current}
                  isClearable={true}
                />
              </div>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3'>
              {emrData &&
                emrData?.length > 0 &&
                emrData?.map((emr, index) => (
                  <React.Fragment key={index}>
                    <SmallEmrCard emr={emr} setData={setViewEmrDetails} patientID={selectedPatient?.value} />
                  </React.Fragment>
                ))}
            </div>
            {emrData === null && (
              <div className='flex w-full h-[40vh] items-center justify-center'>
                <h1 className='text-2xl font-bold text-center'>
                  {!selectedPatient && !emrData
                    ? 'Please select patient to view emr details'
                    : 'No Emr record found for this patient'}
                </h1>
              </div>
            )}
          </div>
        )}
      </div>
      <AppLoader showLoader={loading} />
    </div>
  );
};

export default PatientEMRList;
